import React from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';
import { Autocomplete } from '../../../Autocomplete';

const Custom = props => {
  const { classes, i, mode, error } = props;
  const { label, disabledOnEdit, customComponent: CustomComponent } = i;

  return (
    <div className={classes.inputContainer}>
      <p
        style={{ marginBottom: 5, fontWeight: 400 }}
        className={cn(
          classes.inputLabel,
          disabledOnEdit && mode === 'EDIT' && classes.disabledText,
          error && classes.textLabelError,
        )}
      >
        {label}: {!!error && error}
      </p>
      {/* <div style={{ opacity: 0.5, fontSize: 10 }}>Current number of options: {options.length}</div> */}

      {React.cloneElement(CustomComponent, props)}
      {/* <CustomComponent {...props} /> */}
    </div>
  );
};

export default withStyles(styles)(Custom);
